import { PalmettoIcon } from '@palmetto/dsm-components';
import { Link } from 'react-router-dom';

export const productLinesPath = '/admin/approved-vendors/product-lines';
export const productLinesTitle = 'Energy Backup Product Lines';

interface ProductLineBreadcrumbProps {
  /** Rendered as the trailing, non-navigable crumb. Omit on the Product Lines list itself. */
  current?: string;
}

const linkClass = 'text-text-primary no-underline hover:underline';

// Composed like EquipmentBreadcrumb, which only supports one level under Manufacturers.
export const ProductLineBreadcrumb = ({ current }: ProductLineBreadcrumbProps) => (
  <div className="flex flex-row flex-wrap items-center gap-4 body-200 text-text-secondary">
    <Link to="/admin/approved-vendors" className={linkClass}>
      Approved Vendors
    </Link>
    <PalmettoIcon name="chevronRight" size="sm" />
    <Link to="/admin/approved-vendors/manufacturers" className={linkClass}>
      Manufacturers
    </Link>
    <PalmettoIcon name="chevronRight" size="sm" />
    {current ? (
      <>
        <Link to={productLinesPath} className={linkClass}>
          {productLinesTitle}
        </Link>
        <PalmettoIcon name="chevronRight" size="sm" />
        <span className="text-text-tertiary">{current}</span>
      </>
    ) : (
      <span className="text-text-tertiary">{productLinesTitle}</span>
    )}
  </div>
);
